import { render, staticRenderFns } from "./honorRollModule.vue?vue&type=template&id=d031c0ae&scoped=true"
import script from "./honorRollModule.vue?vue&type=script&lang=js"
export * from "./honorRollModule.vue?vue&type=script&lang=js"
import style0 from "./honorRollModule.vue?vue&type=style&index=0&id=d031c0ae&prod&lang=less&scoped=true"
import style1 from "./honorRollModule.vue?vue&type=style&index=1&id=d031c0ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d031c0ae",
  null
  
)

export default component.exports